import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  .ant-collapse {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    padding: 16px;
  }
`;

export const StyledUl = styled.ul`
  list-style-type: none;
  margin-block-start: 0;
  padding-left: 0;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    padding-left: 32px;
  }
`;
